<template>
  <div class="sceneBuyCardOrderDetail">
    <!-- <div>现场购卡详情</div> -->

    <!-- 订单详情 -->
    <div class="orderDeWrap">
      <!-- 标题 -->
      <title-box :top-title="topTitle"></title-box>

      <!-- 内容 -->
      <div class="orderDeCon">
        <div class="orderDeTopC flex-row jus-b">
          <!-- 订单状态 -->
          <order-state :order-item="currentOrder" :order-state="step"></order-state>

          <!-- 流程 -->
          <order-step :order-item="currentOrder" :order-state="step"></order-step>
        </div>

        <div class="orderDeBotpC flex-row jus-b">
          <!-- 订单信息 -->
          <order-info :order-item="currentOrder" :order-state="step"></order-info>

          <!-- 客户信息 -->
          <customer-info :order-item="currentOrder" :order-state="step"></customer-info>

          <!-- 物流信息 -->
          <logistics-empty :order-item="currentOrder" :order-state="step"></logistics-empty>
        </div>
      </div>

      <!-- 商品信息 -->
      <div class="goodsWrap">
        <goods-info :order-item="currentOrder" ></goods-info>
      </div>
    </div>

    <!-- 弹层 -->
    <remarks v-show="offon"></remarks>

  </div>
</template>

<script>
  import TitleBox from '@/components/Common/TitleBox/TitleBox.1';
  import orderState from './components/OrderState';
  import orderStep from './components/OrderStep';
  import orderInfo from './components/OrderInfo';
  import customerInfo from './components/CustomerInfo';
  import logisticsEmpty from './components/LogisticsEmpty';
  import goodsInfo from './components/GoodsInfo';

  import remarks from './components/Remarks';
  import {getOrderDetail} from '@/api/Order/NumCardOrder/internetBuyCardOrder.js';

  export default {
    name: "sceneBuyCardOrderDetail",
    data() {
      return {
        //标题
        topTitle: {
          title: '现场购卡订单管理',
          subTit: '查看订单详情'
        },
        step: 3,
        offon: false,
        currentOrder: {}
      }
    },
    created() {
      this.initOrderDetail()
    },
    methods: {
      initOrderDetail() {
        // const id = this.$route.query.id;
        // getOrderDetail({order_id: id})
        //     .then(resp => {
        //       this.currentOrder = resp.body
        //     })
        //     .catch(e => console.log(e))
        
        this.currentOrder = {
          order_base: {
            order_id: 'D2018072700002109',
            status_code: '1', //（现场自取：1待支付,2待取卡,4已完成,5已关闭,7已取消）
            note: '',

            order_type: '买号卡', //订单类型：
            price_real: '39.00', //实收款：
            pay_way: '', //支付方式：
            open_account_status: '否', //是否开户：
            open_account_type: '', //开户类型：
            accept_member: '', //受理会员：
            accept_equipment: '', //受理设备：
            order_note: '订单备注信息', //订单备注：

            buyer_name: '王伟', //客户名称：
            sex: '男', //性别：
            nation: '汉', //民族：
            birthday: '1968/06/12', //出生日期：
            certificate_address: '哈尔滨市呼兰区民主街16-3号', //证件地址：
            certificate_num: '230121196806*****', //证件号码：
            sign_office: '哈尔滨市公安局', //签发机关：
            valid_date_begin: '2008/01/01', //有效期开始：
            valid_date_end: '2048/01/01', //有效期结束：
            buyer_phone: '15457767645', //客户联系电话：

            contact_name: '张三',
            contact_number: '1939234234',
            express_name: '圆通快递',
            express_num: '8080909090909090',


            // skus: [ // 订单状态-修改价格时要用到的数据
            //   {
            //     pic_url: '', //运营商品-图片
            //     goods_title: '4G不限量', //运营商品-名称
            //     goods_phone: '13299999999', //运营商品-号码
            //     goods_busi: '买号卡', //运营商品-业务
            //     goods_operator: '中国联通', //运营商品-运营商

            //     sku_price: '24', //单价
            //     sku_quantity: '1', //数量
            //   }
            // ],
          },
          // 底部商品信息的数据
          order_skus: [
            {
              pic_url: '', //商品信息-图片
              goods_title: '4G不限量', //商品信息-名称
              goods_phone: '13299999999', //商品信息-号码
              goods_operator: '中国联通', //商品信息-运营商
              goods_specs: '国内漫游_910_500371,所有来去话,流量充值卡达量提醒,无流量套餐消费提醒,话费返还提醒,普通流量产品提醒,彩色流量产品达量提醒,短彩信业务达量提醒,WIFI时长达量提醒,语音业务达量提醒,翼支付交费助手。', //商品规格
              sku_quantity: '1', //数量
              sku_price: '24', //价格(元)
            }
          ],
          
        }
      },
      
    },
    components: {
      TitleBox,
      orderState,
      orderStep,
      orderInfo,
      customerInfo,
      logisticsEmpty,
      goodsInfo,
      remarks
    }
  }
</script>

<style scoped>
  .sceneBuyCardOrderDetail {
    /* height: auto; */
    /* min-width: 1100px; */
    /* min-width: 1056px; */
    min-width: 1090px;
  }

  .orderDeCon {
    margin-top: 15px;
  }

  .orderDeBotpC {
    margin-top: 12px;
  }

  .goodsWrap {
    padding: 14px 14px 15px;
    margin-top: 13px;
    background: #fff;
  }
</style>
